const FreePlanToastContent = ({ onOpenBilling }) => (
  <div className="min-w-0 flex-1 overflow-x-auto">
    <div className="flex w-fit items-center gap-2.5 whitespace-nowrap text-[12.5px] text-brand-gold">
      <strong className="font-bold">
        need2know is free. Customizing your targeting is paid.
      </strong>
      <span>Custom recipes and groups run on credits, charged by what they use.</span>
      <span className="text-brand-gold">Credits start at a $10 minimum and don't expire.</span>
      <button
        type="button"
        onClick={onOpenBilling}
        className="font-semibold text-brand-gold hover:underline"
      >
        How billing works
      </button>
    </div>
  </div>
);

export default FreePlanToastContent;
